<template>
<div :show_report_50bang="pageAdInfo.show_report_50bang" :uid="pageAdInfo.uid" :compName="compName" :tag="tag">
  <div :id="pageAdInfo.divId"></div>
</div>
</template>
<script>
import ad from '../../api/ad';
import util from '../../api/util';
import stats from '../../api/statistics';

export default {
  name: 'NewsTplAdBaidu',
  props: [
    'newsAdInfo', 'compName', 'tag', 'pageType', 'tagIdx', 'report_max_line_300'
  ],
  data () {
    return {
      pageAdInfo: {},
      iframeRect: {
        stop: 0,
        wheight: 0
      }
    }
  },
  mounted () {
    this.$bus.$on('showReport', (data) => {
      this.iframeRect = data.rect;
      this.showReport();
    });
    this.initAdsInfo();
  },
  methods : {
    /**
     * 初始化广告数据，并加载百度广告
     */
    initAdsInfo () {
      this.pageAdInfo = this.newsAdInfo;
      this.$nextTick(() => {
        let dependJs = 'https://newsie.2345.cc/newtab/common/e2_bdm.js';
        let renderBdwmAd = () => {
          ad.getAdsList('bdwm', {
            divId: this.newsAdInfo.divId,
            uid: this.newsAdInfo.uid
          });
          let curNewsCnt = document.querySelector('#' + this.tag);
          this.$bus.$emit('sendMessage', {
            action: 'refreshHeigh',
            height: parseInt(curNewsCnt.offsetHeight) + 54 + (this.report_max_line_300[this.tagIdx] === 1 ? 100 : 0),
            data: {
              height: parseInt(curNewsCnt.offsetHeight) + 54 + (this.report_max_line_300[this.tagIdx] === 1 ? 100 : 0),
              loadState: true
            }
          });
          this.showReport();
        };
        if (!!document.querySelector(`script[src="${dependJs}"]`)) { // JS文件已加载
          if (window.hasOwnProperty('BAIDU_CLB_fillSlotAsync')) { // 异步方法挂载完成
            renderBdwmAd();
          } else { // JS已加载， 但是方法尚未初始化完成
            setTimeout(() => {
              renderBdwmAd();
            }, 200);
          }
        } else {
          util.loadJs(dependJs, () => {
            renderBdwmAd();
          });
        }
      });
    },
    /**
     * 展现统计
     */
    showReport () {
      if (document.querySelector('#' + this.pageAdInfo.divId)) {
        if (util.isElementInViewport(this.pageAdInfo.divId, this.iframeRect, this.pageType) && this.pageAdInfo['show_report_50bang'] !== 'reported') {
          stats.ajax99(this.pageAdInfo.show_report_50bang);
          // console.log('reported', `${this.pageAdInfo.divId}-${this.pageAdInfo.show_report_50bang}-showrepoted`);
          this.pageAdInfo['show_report_50bang'] = 'reported';
        }
      }
    }
  }
}
</script>
